module.exports = "<div class=\"ot-modal ot-burger-menu\">\n  <div>\n    <ot-link-list params=\"{type: 'header'}\"></ot-link-list>\n  </div>\n</div>\n"


/*****************
 ** WEBPACK FOOTER
 ** ./src/templates/modals/burger.html
 ** module id = 291
 ** module chunks = 1
 **/